export enum ContentTypes {
  ARTICLE = 'article',
  GALLERY = 'gallery',
  PAGE = 'page',
  NEWS_BRIEF = 'news_brief',
  DIGITAL_PUBLICATION = 'digitalpublication',
  SINGLE_SPONSOR = 'singlesponsor',
  CONTENT_SET = 'contentset',
}
